import { Pipe, PipeTransform } from '@angular/core'

import { localizeString } from '@flowx/core-sdk'

@Pipe({
  name: 'flxLocalize',
  standalone: true,
})
export class FlxLocalizePipe implements PipeTransform {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(value: string, language?: string): string {
    return localizeString(value)
  }
}
